import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Login from '@/views/Login'
import VerifyPhone from '@/views/VerifyPhone'
import PlanDetail from '@/views/PlanDetail'
import Paymenthly from '@/views/Paymenthly'
import Profile from '@/views/Profile'
import PaymentSuccessfull from '@/views/PaymentSuccessfull'
import History from '@/views/History'
import policy from '@/views/policy'
import salecard from '@/views/salecard'
import NavBar from '@/components/NavBar'
import { getUser } from '../store/user'
import newUser from '@/views/newUser'
import nuinfo from '@/views/nuinfo'
import service from '@/views/service'
import police from '@/views/police'
import i18n from '../locales/i18n'
import { applyLocaleFromRoute } from '../utils/locale'
Vue.use(Router)

let router = new Router({
    mode: 'history',
    base:'/goods/',
    routes: [ {
        path: '/salecard',
        name: "salecard",
        component: salecard
    },
    {
        path: '/newUser',
        name: "newUser",
        component: newUser
    },
    {
        path: '/nuinfo',
        name: "nuinfo",
        component: nuinfo
    },
      {

        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/service',
        name: 'service',
        component: service
      },
      {
        path: '/police',
        name: 'police',
        component: police
      },

        {
            path: '/',
            name: 'navbar',
            component: NavBar,
            children: [{
                path: '/',
                name: 'index',
                component: Index
            },  {
                path: 'verify',
                name: "verify",
                component: VerifyPhone
            }, {
                path: 'plan-detail',
                name: 'plan-detail',
                component: PlanDetail
            }, {
                path: 'paymenthly',
                name: 'Paymenthly',
                component: Paymenthly
            }, {
                path: 'profile',
                name: 'profile',
                component: Profile
            }, {
                path: 'payment-successfull',
                name: 'payment-successfull',
                component: PaymentSuccessfull
            }, {
                path: 'history/:category',
                name: "history",
                component: History,
                props: {
                    category: String
                }
            },{
                path: 'policy',
                name: "policy",
                component: policy
            },{
                path: '/:id?',
                name: 'index',
                component: Index
            }]
        },
    ],
})

router.beforeEach((to, from, next) => {
    applyLocaleFromRoute(to, i18n)

    let noValidPages = ['login', 'verify', 'index', 'service', 'police']
    if (noValidPages.includes(to.name))
        return next()

    let user = getUser()
    if (!user && to.name!="salecard"&& to.name!="newUser"&& to.name!="nuinfo"&& to.name=="paymenthly") {
      console.log('------------paymenthly')
        next({ path: '/login' })
    } else if (to.name === 'profile' && from.name !== 'verify') {
        next({ path: '/plan-detail' })
    } else {
        next()
    }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}




export default router



// WEBPACK FOOTER //
// ./src/router/index.js